import MicroModal from 'micromodal';

"use strict"
MicroModal.init({
  disableScroll: true,
  awaitOpenAnimation: true,
  awaitCloseAnimation: true,
});

// Scroll to top
const scrollTopFooterButtonElement = document.querySelector('#scrollToTop');
const scrollTopButtonElement = document.querySelector('#scroll-button');
const heroElementHeight = document.querySelector('.hero').offsetHeight;

scrollTopFooterButtonElement.addEventListener('click', function() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  })
})

scrollTopButtonElement.addEventListener('click', function() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  })
})

// Scroll progress
const progressBar = document.querySelector("#progress-bar");
let scrollHeight;
let currentScrollPosition;

window.addEventListener("scroll", function() {
  scrollHeight = document.body.clientHeight - window.innerHeight;
  if (!!window.MSInputMethodContext && !!document.documentMode) {
    currentScrollPosition = Math.floor(window.pageYOffset);
  } else {
    currentScrollPosition = Math.floor(window.scrollY);
  }

  const progressPercent = Math.round(currentScrollPosition / (scrollHeight * 0.01))
  progressBar.style.width = progressPercent + '%';

  if (currentScrollPosition > heroElementHeight) {
    scrollTopButtonElement.classList.add('active');
  } else {
    scrollTopButtonElement.classList.remove('active');
  }
})

// FAQ tabs

const tabsHeads = document.querySelectorAll('.faq-tab-head');
const tabsHeadsToggle = document.querySelectorAll('.faq-tab-head__toggle');
const tabsBodies = document.querySelectorAll('.faq-tab-body');

for (let i = 0; i < tabsHeads.length; i++) {
  tabsHeads[i].addEventListener("click", function() {
    if (tabsHeadsToggle[i].classList.contains('active')) {
      tabsHeadsToggle[i].classList.remove('active');

      tabsBodies[i].style.maxHeight = 0 + 'px';

      setTimeout(function() {
        tabsBodies[i].style.display = 'none';
        tabsBodies[i].style.maxHeight = '';
      }, 300)
    } else {
      tabsHeadsToggle[i].classList.add('active');

      tabsBodies[i].style.display = 'block';
      const height = tabsBodies[i].offsetHeight;
      tabsBodies[i].style.maxHeight = 0 + 'px';
      setTimeout(function() {
        tabsBodies[i].style.maxHeight = height + 'px';
      })
    }
  });
}

function isMobile(a) {
  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) {
    return true
  } else {
    return false;
  }
}

// contact-popup
const contactPopupButtonDesktop = document.querySelector('.contact-popup-button.desktop');
const contactPopupButtonMobile = document.querySelector('.contact-popup-button.mobile');
const contactPopup = document.querySelector('.contact-popup');

if (!isMobile(navigator.userAgent||navigator.vendor||window.opera)) {
  contactPopupButtonMobile.style.display = "none";
  
  contactPopupButtonDesktop.addEventListener('click', function() {
    if (contactPopupButtonDesktop.classList.contains('active')) {
      contactPopupButtonDesktop.classList.remove('active');
      contactPopup.classList.remove('active');
      setTimeout(function() {
        contactPopup.style.display = 'none';
      }, 200);
    } else {
      contactPopupButtonDesktop.classList.remove('not-clicked');
      contactPopupButtonDesktop.classList.add('active');
      contactPopup.style.display = 'flex';
      
      setTimeout(function() {
        contactPopup.classList.add('active');
      });
    }
  });
} else {
  contactPopupButtonDesktop.style.display = "none";
}

// Form
function mailSend(form, data) {
  const res = fetch("mail.php", {
    method: 'post',
    headers: {
      "Content-type": 'application/json; charset="utf-8"'
    },
    body: JSON.stringify(data),
  }).then(function (res) {
    if (res.ok) {
      form.reset();
    }
  })
}

const contactSectionForm = document.querySelector(".contact-form form");
const contactSectionFormSuccess = document.querySelector(".contact-form--success");
const contactSectionFormName = document.querySelector(".contact-form form input[type=text]");
const contactSectionFormPhone = document.querySelector(".contact-form form input[type=tel]");

const contactPopupForm = document.querySelector(".contact-popup-form");
const contactPopupFormSuccess = document.querySelector(".contact-popup-form--success");
const contactPopupFormPhone = document.querySelector(".contact-form form input[type=tel]");

contactPopupForm.addEventListener("submit", (e) => {
  e.preventDefault();
  let data = {
    phone: contactPopupFormPhone.value
  }

  if (contactPopupFormPhone.value) {
      fetch("mail.php", {
        method: 'post',
        headers: {
          "Content-type": 'application/json; charset="utf-8"'
        },
        body: JSON.stringify(data),
      }).then(function (res) {
        if (res.ok) {
          contactPopupForm.reset();
          contactPopupForm.style.display = "none"
          contactPopupFormSuccess.style.display = "block";
          setTimeout(function() {
            contactPopupFormSuccess.style.opacity = "1";
          })
        }
      })
    }
})

contactSectionForm.addEventListener("submit", (e) => {
  e.preventDefault();
  let data = {
    name: contactSectionFormName.value,
    phone: contactSectionFormPhone.value
  }

  if (contactSectionFormName.value && contactSectionFormPhone.value) {
      fetch("mail.php", {
        method: 'post',
        headers: {
          "Content-type": 'application/json; charset="utf-8"'
        },
        body: JSON.stringify(data),
      }).then(function (res) {
        if (res.ok) {
          contactSectionForm.reset();
          contactSectionForm.style.display = "none"
          contactSectionFormSuccess.style.display = "block";
          setTimeout(function() {
            contactSectionFormSuccess.style.opacity = "1";
          })
        }
      })
    }
})

// Phone mask
const phoneInputs = document.querySelectorAll('input[type=tel]');

for (let i = 0; i < phoneInputs.length; i++) {
  phoneInputs[i].addEventListener('input', function (e) {
    var value = e.target.value.replace(/(?!^\+)\D/g, '');
    if (value.indexOf('+') !== -1) {
      e.target.value = value.slice(0, 12);
    } else {
      e.target.value = value.slice(0, 11);
    }
  });
}